import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';
import OrderingButton from 'components/base/OrderingButton';
import MentorCard from 'components/mentoring/mentor/MentorCard';
import { getInterestedMentors } from 'libs/api/user';
import { useDataApi, usePagination } from 'libs/hooks';
import { TListResponse, TPagination } from 'modules/types';
import { TSimpleMentor } from 'modules/user';
import { Col, Row, Typography, List } from 'antd';

const { Text, Title } = Typography;
const InterestedMentor = () => {
  const [pagination, setPagination] = usePagination(6);
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
  };
  const getPromise = getInterestedMentors.bind(null, {
    params: {
      current: pagination.current,
      pageSize: pagination.pageSize,
      q: pagination.q,
      ordering: pagination.ordering,
      mentoringField: currentUser?.primary_field,
    },
  });

  const [{ data, loading }, setCallback] = useDataApi<TListResponse<TSimpleMentor>>(getPromise, {
    contents: [],
    last: false,
  });

  useEffect(() => {
    setCallback(() => getPromise);
  }, [pagination]);

  return (
    <div style={{ minHeight: '300px', maxWidth: '600px' }}>
      <Row id='card-list-header' justify='space-between' gutter={[16, 6]}>
        <Col span={12}>
          <Text style={{ color: '#000' }} strong>
            총 {get(data, 'total')}명의 멘토
          </Text>
        </Col>
        <Col span={12}>
          <div style={{ float: 'right' }}>
            <OrderingButton
              pagination={pagination}
              reloadPage={reloadPage}
              defaultKey='-score_average'
              orderingList={{
                '-score_average': '평점 높은순',
                '-num_of_rater': '리뷰 많은순',
              }}
            />
          </div>
        </Col>
      </Row>
      <List
        pagination={{
          ...pagination,
          total: get(data, 'total', 0),
          position: 'bottom',
          hideOnSinglePage: true,
          onChange: (page) => {
            reloadPage({
              current: page,
              pageSize: pagination.pageSize,
            });
          },
        }}
        loading={{ spinning: loading, delay: 1000 }}
        style={{ paddingTop: '20px' }}
        grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
        dataSource={get(data, 'contents')}
        renderItem={(item) => (
          <List.Item>
            <MentorCard mentor={item} pagination={pagination} reloadPage={reloadPage} maxWidth={300} />
          </List.Item>
        )}
      />
    </div>
  );
};

export default InterestedMentor;
